import {EmployeeSignUpData} from "../../domain/dtos/employee-sign-up-data";

export class EmployeeSignUpDataMapper {
    static serialize(param: EmployeeSignUpData): any {
        return {
            billing_code: param.cif,
            name: param.name,
            surname: param.surname,
            residence: param.address,
            town: param.city,
            postal_code: param.postalCode,
            telephone: param.phone,
            email: param.email,
            workstation: param.workplace,
            recaptchaToken: param.recaptchaToken,
        };
    }
}
